// GENERATED by 'pnpm cfg apply <env>' (scripts/config/generatePublicConfig.ts) from the central
// public/production.json. Do NOT edit by hand — change the central file and regenerate.
export const config = {
    "ENV": "prod",
    "IS_LOCAL": false,
    "API_ROOT_URL": "https://api1.roo.money",
    "ADMIN_API_ROOT_URL": "https://api-admin.roo.money",
    "ADMIN_PORTAL_URL": "https://admin.roo.money",
    "API_LATEST_ROOT_URL": "https://api-latest.roo.money",
    "WEB_APP_URL": "https://app.roo.money",
    "ROO_PIPE_URL": "https://pipe2.roo.money/events",
    "LOG_CONFIG": {
        "debugEnabled": true,
        "reduceNoise": true,
        "enableLocalOutput": false
    },
    "FIREBASE_CONFIG": {
        "apiKey": "AIzaSyBoVhDrdLqaCgzsf6bfyVfU5UBT6pd4usA",
        "authDomain": "roo-prod-f1201.firebaseapp.com",
        "databaseURL": "https://roo-prod-f1201-default-rtdb.firebaseio.com",
        "projectId": "roo-prod-f1201",
        "storageBucket": "roo-prod-f1201.appspot.com",
        "messagingSenderId": "621623775145",
        "appId": "1:621623775145:web:d39a31bcb416e081063eb8",
        "measurementId": "G-34MDKGNFH2"
    },
    "GOOGLE_AUTH": {
        "iosClientId": "638773526270-3a4bdda941c486kc1nah4e8mse79d90t.apps.googleusercontent.com",
        "iosClientIdReversed": "com.googleusercontent.apps.638773526270-3a4bdda941c486kc1nah4e8mse79d90t",
        "androidClientId": "638773526270-gdpffibv22l2he1v71n5ki1j7ga9ilrk.apps.googleusercontent.com",
        "androidClientIdReversed": "com.googleusercontent.apps.638773526270-gdpffibv22l2he1v71n5ki1j7ga9ilrk",
        "webClientId": "638773526270-b6sgthio0vgrcs3ma3dmngidmbt524vo.apps.googleusercontent.com"
    },
    "APPLE_AUTH": {
        "webServicesId": "money.roo.app.web"
    },
    "POSTHOG_CONFIG": {
        "apiKey": "phc_NcJnzuQLpETCC8jwhTBJ3yrmaQNtjrS8zrMawIjIZZC",
        "enableSessionReplay": true
    },
    "AGGREGATORS": {
        "MX": {
            "BASE_PATH": "https://api.mx.com"
        }
    }
};
//# sourceMappingURL=public.js.map